import { Button } from '@cropler/ui-kit';
import { BreakpointMobileUp } from '../../constants/ui';
import { getFilterParametersMap } from '../../utils/filter';

const MapFilterMetricsParam = ({ t, param, clickFilterParameter, isDarkTheme = true, widthViewport }) => {
  const FilterParametersMap = getFilterParametersMap(t);
  const { Icon } = FilterParametersMap[param];

  return (
    <Button
      type={isDarkTheme ? 'primary' : 'secondary'}
      icon={<Icon />}
      size={widthViewport < BreakpointMobileUp ? 'large' : null}
      onClick={clickFilterParameter}
    ></Button>
  );
};

export default MapFilterMetricsParam;
